import React from "react";
import { all, call, takeEvery, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { Toast } from "../../utils/helper";
import {
  GET_BANNERS,
  GET_DASHBOARD_DETAILS,
  GET_WHATS_NEW,
} from "../action/types";
import {
  getDashboardDetailsSuccess,
  getDashboardDetailsFailure,
  getBannersSuccess,
  getBannersFailure,
  getWhatsNewSuccess,
  getWhatsNewFailure,
} from "../action";
import POSITION from "../../utils/api/candidate";
import USERS from "../../utils/api/users";
function* getDashboardDetailsRequest() {
  try {
    const endpoint = `incscreen/positions/dashboardStats`;
    const res = yield POSITION.get(endpoint);
    if (res.status === 201 || res.status === 200) {
      yield put(getDashboardDetailsSuccess(res.data.result));
    }
  } catch (e) {
    yield put(getDashboardDetailsFailure());
    yield e?.response?.data?.message &&
      e?.response?.data?.message !==
        "Your session has been expired, please login again!" &&
      toast.error(<Toast msg={e?.response?.data?.message} />, {
        autoClose: 5000,
        toastId: e?.response?.data?.message,
      });
  }
}
function* getBannersRequest() {
  try {
    const res = yield USERS.get("employers/getBanners");
    if (res.status === 201 || res.status === 200) {
      yield put(getBannersSuccess(res.data.result));
    } else yield put(getBannersFailure());
  } catch (e) {
    yield put(getBannersFailure());
    yield e?.response?.data?.message &&
      e?.response?.data?.message !==
        "Your session has been expired, please login again!" &&
      toast.error(<Toast msg={e?.response?.data?.message} />, {
        autoClose: 5000,
        toastId: e?.response?.data?.message,
      });
  }
}
const getAnnouncementsFromResponse = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.announcement)) return data.announcement;
  if (data.result) return getAnnouncementsFromResponse(data.result);
  return [];
};

function* getWhatsNewRequest(action) {
  try {
    const { productId } = action.payload || {};
    if (productId == null || productId === "") return;
    const res = yield USERS.get("/users/notifications/whats-new", {
      params: { productId },
    });
    if (res.status === 200 || res.status === 201) {
      const result = res.data?.result ?? res.data;
      const isActive = result?.status === true;
      const announcements = getAnnouncementsFromResponse(res.data);
      const payload =
        isActive && announcements.length > 0 ? announcements : null;
      yield put(getWhatsNewSuccess(payload));
      if (typeof action?.payload?.callback === "function") {
        yield call(action.payload.callback, payload);
      }
    }
  } catch (e) {
    yield put(getWhatsNewFailure());
  }
}
export function* watchGetDashboardDetailsAPI() {
  yield takeEvery(GET_DASHBOARD_DETAILS, getDashboardDetailsRequest);
}
export function* watchGetBannersAPI() {
  yield takeEvery(GET_BANNERS, getBannersRequest);
}
export function* watchGetWhatsNewAPI() {
  yield takeEvery(GET_WHATS_NEW, getWhatsNewRequest);
}
export default function* rootSaga() {
  yield all([
    watchGetDashboardDetailsAPI(),
    watchGetBannersAPI(),
    watchGetWhatsNewAPI(),
  ]);
}
